<div id="wrapper" [style.maxHeight]="maxHeight" [style.maxWidth]="maxWidth">
  <mat-icon id="close" [mat-dialog-close]="true">close</mat-icon>
  <mat-icon
    [ngClass]="{ disabled: currentCarouselIndex === 0 }"
    (click)="prevSlide()"
    class="control left"
    >chevron_left</mat-icon
  >
  <ng-container>
    <img [src]="data.images?.[currentCarouselIndex]?.url" [style.maxHeight]="maxHeight" [style.maxWidth]="maxImageWidth" />
  </ng-container>
  <mat-icon
    [ngClass]="{ disabled: currentCarouselIndex === data.images.length - 1 }"
    (click)="nextSlide()"
    class="control right"
    >chevron_right</mat-icon
  >
</div>
